module.exports = {"id":"165109","name":"Ştefan Radu","rating":"80","photo":"./data/images/photos/1/165109.png","club":{"name":"Lazio Rome","logo":"./data/images/clubs/LazioRome.png"},"positions":["DC","DG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/StefanRadu0.json
// module id = 4012
// module chunks = 0